@if (contentBlockData(); as data) {
  <app-content-block-card [kind]="block().kind" [data]="data" [blockId]="block().id" />
} @else if (planData(); as data) {
  <app-plan-card [data]="data" [status]="block().status" />
} @else {
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>{{ block().id }} · {{ block().kind }} (raw)</mat-panel-title>
    </mat-expansion-panel-header>
    <andypf-json-viewer theme="material-lighter" [data]="block()" indent="2" expanded="1" show-toolbar="false" class="json-viewer"></andypf-json-viewer>
  </mat-expansion-panel>
}
